// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1MvfV","emails":"CreateEditClinics_emails__1853K","emailTagLabel":"CreateEditClinics_emailTagLabel__3i9Wj"};